import React from 'react';
import { applyStyles } from 'util/helpers';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import Jump from 'components/common/Jump';
import Bank from './components/Bank';
import Credit from './components/Credit';
import i18n from 'i18n';
import Colors from 'constants/colors';
import Breadcrumbs from 'components/common/Breadcrumbs';
import GrayHeader from 'components/common/GrayHeader';
import FontStyles from 'constants/font-styles';

const aboutPayment = ({ className, location: { pathname } }) => (
  <div className={className}>
    <GrayHeader text={i18n.t('about:payment:grayHeader')} />
    <Breadcrumbs currentPath={pathname} />
    <Jump />
    <section>
      <p>{i18n.t('about:payment:description')}</p>
    </section>
    <section>
      <Bank />
    </section>
    <section>
      <Credit />
    </section>
  </div>
);

const commonStyle = css`
  p {
    ${FontStyles.text8};
    margin-bottom: 0;
  }

  section {
    border-bottom: 1px solid ${Colors.gray2};

    &:last-child {
      border-bottom: none;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  max-width: 886px;
  margin-left: auto;
  margin-right: auto;

  ${Breadcrumbs} {
    margin-top: 12px;
  }

  p {
    margin-top: 36px;
  }

  section {
    padding-bottom: 72px;

    &:last-of-type {
      padding-bottom: 160px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 16px;

  ${Breadcrumbs} {
    margin-top: 6px;
  }

  section {
    > p {
      ${FontStyles.text6};
    }

    padding-bottom: 32px;

    &:last-child {
      padding-bottom: 48px;
    }
  }
`;

export default applyStyles(aboutPayment)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Payment/index.js